// Per-page SEO metadata. Used by <SEO> component.
// Admin can override global defaults via /admin/settings → SEO section.
//
// === Keyword strategy (internal — not shown to visitors) ===
//
// Company positioning (per founder briefing):
//   * Super-luxury real estate developer in Maharashtra, India.
//   * 3 large projects active across Maharashtra; Silva City is the flagship
//     and currently the best upcoming township.
//   * USP: every Seetai project is structured to provide a regular income
//     stream to investors — positioned as best-in-class investment opportunity
//     rather than a pure end-use plot.
//
// Keyword tiers we target:
//   1. Branded     — Seetai Properties, Silva City
//   2. Geographic  — Pune, Maharashtra, Khor, Bhandgaon, Jejuri
//   3. Category    — luxury / super luxury real estate, premium NA plots,
//                    plotted township, master plan township
//   4. Intent      — investment plots, real estate investment Maharashtra,
//                    regular income real estate, passive income property,
//                    plot for sale Pune
//   5. Long-tail   — best luxury township Maharashtra, NA plots near Pune
//                    airport, Pune Solapur highway plots, etc.

const SHARED_KEYWORDS = [
  // Brand
  "Seetai Properties",
  "Seetai Properties Pvt Ltd",
  "Silva City",
  "Silva City Bhandgaon",
  // Category
  "super luxury real estate Maharashtra",
  "luxury real estate developer Pune",
  "premium real estate developer Maharashtra",
  "luxury township Pune",
  // Geography
  "real estate Pune",
  "plots in Bhandgaon",
  "plots in Khor",
  "Jejuri plots",
  "plots near Pune Solapur highway",
  // Investment angle
  "real estate investment Maharashtra",
  "best investment plot Pune",
  "income generating real estate India",
  "passive income real estate",
  "high return real estate investment",
].join(", ");

export const PAGE_SEO = {
  home: {
    path: "/",
    title: "Crafting Luxury. Building Legacy.",
    description:
      "Seetai Properties — super-luxury real estate developer in Maharashtra. Three flagship township & plotted projects across the state, anchored by Silva City — a 66-acre NA plotted township in Khor, Bhandgaon engineered for long-term wealth creation and regular income for investors.",
    keywords:
      `${SHARED_KEYWORDS}, super luxury real estate India, luxury real estate developer India, Maharashtra plotted township, township investment, NA plots Maharashtra, Crafting Luxury Building Legacy`,
  },
  about: {
    path: "/about",
    title: "About Us — Visionaries in Modern Real Estate",
    description:
      "Meet Seetai Properties Pvt. Ltd. — Maharashtra's super-luxury township developer. Led by visionary directors, vertically integrated across land assembly, township design, construction, and investor-grade asset management. Currently delivering 3 landmark projects across Maharashtra.",
    keywords:
      `${SHARED_KEYWORDS}, about Seetai Properties, Seetai Properties directors, luxury developer Maharashtra leadership, super luxury real estate company India`,
  },
  projects: {
    path: "/projects",
    title: "Silva City — 66 Acre Super-Luxury NA Plotted Township",
    description:
      "Explore Silva City — Seetai Properties' flagship 66-acre Town Planning approved super-luxury NA plotted township at Khor, Bhandgaon. Plots 1,200 – 5,000 sq. ft. Designed as a long-term wealth-creation asset with steady appreciation and regular income potential for investors.",
    keywords:
      `${SHARED_KEYWORDS}, Silva City township, Silva City master plan, 66 acre township Pune, NA plots Khor, NA plots Bhandgaon, TP approved plots Maharashtra, super luxury plotted development, township master plan, premium plots near Pune airport, plotted investment Maharashtra, luxury township Bhandgaon`,
  },
  services: {
    path: "/services",
    title: "Services — End-to-End Super-Luxury Real Estate Solutions",
    description:
      "From land assembly to white-glove asset management — Seetai Properties delivers vertically integrated super-luxury real estate services across Maharashtra. Township master-planning, premium construction, PropTech-driven investor-grade asset management.",
    keywords:
      `${SHARED_KEYWORDS}, real estate development services Maharashtra, township master planning, luxury construction Pune, PropTech India, real estate asset management, NA plotting services, integrated real estate developer`,
  },
  contact: {
    path: "/contact",
    title: "Contact — Let's Build Your Dream Together",
    description:
      "Connect with Seetai Properties' private advisory desk — site visits to Silva City, investor briefings on our Maharashtra portfolio, and bespoke plot consultations. Located at Airport Link Road, Jejuri Road, Bhandgaon. WhatsApp, phone and email available.",
    keywords:
      `${SHARED_KEYWORDS}, contact Seetai Properties, Silva City site visit booking, real estate advisory Pune, Bhandgaon plots enquiry, super luxury plot consultation, investor briefing Maharashtra`,
  },
  terms: {
    path: "/terms",
    title: "Terms & Conditions",
    description:
      "Read the Terms & Conditions of using the Seetai Properties website and services.",
    keywords: "Seetai Properties terms and conditions, Seetai legal, real estate website terms",
    robots: "noindex,follow",
  },
  privacy: {
    path: "/privacy",
    title: "Privacy & Security Policy",
    description:
      "Read the Privacy & Security Policy of Seetai Properties — how we collect, store, and protect your personal information.",
    keywords: "Seetai Properties privacy policy, data protection real estate India, Seetai legal",
    robots: "noindex,follow",
  },
  notfound: {
    path: "*",
    title: "Page Not Found",
    description: "The page you are looking for could not be found.",
    robots: "noindex,nofollow",
  },
};

export const getPageSeo = (key) => PAGE_SEO[key] || {};
